import { useSyncExternalStore } from 'react'

const DESKTOP_BREAKPOINT = 1280

/**
 * Subscribes to media query changes for desktop breakpoint detection.
 */
function subscribe(callback: () => void) {
	const mql = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`)
	mql.addEventListener('change', callback)
	return () => mql.removeEventListener('change', callback)
}

/**
 * Returns current desktop state based on window width.
 */
function getSnapshot() {
	return window.innerWidth >= DESKTOP_BREAKPOINT
}

/**
 * Returns default desktop state for server-side rendering.
 */
function getServerSnapshot() {
	return true
}

/**
 * Hook that detects if the current viewport is desktop-sized (>= 1280px).
 * Uses `useSyncExternalStore` to subscribe to media query changes.
 *
 * @returns `true` if viewport width is desktop or larger, `false` otherwise
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const isDesktop = useIsDesktop()
 *   return <div>{isDesktop ? 'Desktop view' : 'Mobile/Tablet view'}</div>
 * }
 * ```
 */
export function useIsDesktop() {
	return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
